import { TriggerStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { shouldSkipSmartSendingForTriggerKey } from "@redotech/redo-model/advanced-flow/automation-utils";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { useDefaultRuleEditContext } from "../../../../rules/default-rule-edit-context";
import { PartialWithRequiredType, StepTypeDetailsProps } from "../../steps";

export function ShouldSkipSmartSendingInspector({
  step,
  setStep,
}: StepTypeDetailsProps<PartialWithRequiredType<TriggerStep>>) {
  // Trigger is fixed in default-rule templates.
  const isDefaultRuleEdit = useDefaultRuleEditContext() !== null;

  if (!step.key) {
    // should never happen
    return null;
  }
  if (shouldSkipSmartSendingForTriggerKey(step.key)) {
    // Only show on automations that we don't already skip smart sending for.
    return null;
  }
  return (
    <Flex dir="column" gap="md">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Smart sending
      </Text>
      <Text fontSize="xxs" textColor="secondary">
        By default, most automations will skip sending a message if we have
        recently sent a message via the same channel to that customer. Bypassing
        that protection may result in excessive sending.
      </Text>
      <RedoToggle
        disabled={isDefaultRuleEdit}
        label="Bypass smart sending protection"
        setValue={(value) => {
          if (isDefaultRuleEdit) {
            return;
          }
          setStep({ ...step, shouldSkipSmartSending: value });
        }}
        size="xs"
        value={step.shouldSkipSmartSending ?? false}
      />
    </Flex>
  );
}
